import './eventi-list.scss';

export class EventiList {}
